<template>
    <div class="helps-article">
        <p class="title">{{ article.title }}</p>
        <p class="cont" v-if="detailData">
          <VueMarkdown>{{this.detailData[0].content}}</VueMarkdown>
        </p>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js";
import VueMarkdown from 'vue-markdown'
export default {
  name: 'HelpsArticle',
  components: { VueMarkdown },
  mounted() {
    this.$Loading.start()
    doPost(
      {action: 'actitle_details', acticle_id: this.$route.query.subId },
      (data) => {
        if (data.status == 200) {
          this.detailData = data.data;
          this.$Loading.finish()
        }
      }
    )
  },
  data() {
    return {
      article: {},
      detailData: ""
    };
  },
  methods: {
  },
  created() {
    this.article = this.$route.query
  }
}
</script>

<style lang="stylus" scoped>
  .helps-article
      width 80%
      display inline-block
      margin-left 36px
      .title
        padding 10px 0
        font-size 25px
        margin-bottom 15px
        line-height 25px
        font-size 14px
  .helps-article p
    line-height 25px
  .list-location
    cursor pointer
  @media screen and (max-width: 1114px)
    .helps-article
      width 70%
  @media screen and (max-width: 758px)
    .helps-article
      width 100%
      margin 0
  @media screen and (max-width: 456px)
    .helps-article
      line-height 12px
    .helps-article .cont
      margin-bottom .56rem
      line-height 22px
</style>




// WEBPACK FOOTER //
// src/pages/Tutorial/components/HelpsArticle.vue